export const OPEN_TABLE = 'OPEN_TABLE'
export const CLOSE_TABLE = 'CLOSE_TABLE'
export const SET_TABLE_LAYER = 'SET_TABLE_LAYER'
export const SET_TABLE_STATUS = 'SET_TABLE_STATUS'

export const openTable = (titleid, data) => ({
  type: OPEN_TABLE,
  titleid,
  data
})

export const closeTable = () => ({
  type: CLOSE_TABLE
})

export const setTableLayer = (titleid) => ({
  type: SET_TABLE_LAYER,
  titleid
})

export const setTableStatus = (status) => ({
  type: SET_TABLE_STATUS,
  status
})
